import {createContext} from 'react'
import type {NavigatorAppRegistration} from './react-app-registry'

export interface AppContextType {
  routes: NavigatorAppRegistration['routes']
}

export const AppContext = createContext<AppContextType>(null as unknown as AppContextType)
